import {NotificationHandler} from './notification.handler';

export class CopyDataHelper {

  public static copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    NotificationHandler.notification($localize`:Notifications|Value copied message@@notifications-value-copied-message:Value copied to the clipboard`);
  }
}
